<template lang='pug'>
span
  v-row(v-if='loading' style='height: 100%; justify-content: center; align-items: center')
    v-col(cols='auto')
      v-progress-circular(
        size='120'
        width='4'
        indeterminate
        color='rgba(200, 200, 200, 0.7)')
        b(style='font-size: 14px; color: rgba(200, 200, 200, 0.7)') {{$t('selectSnapshot.loading')}}
  md-card(v-else style='background-color: #fafafa')
    md-card-content(style='background-color: #fafafa')
      md-table.paginated-table.table-striped.table-hover(
        :value='tableData'
        style='background-color: #fafafa',
        :key='tableKey')
        md-table-toolbar
          md-field
            label(for='pages') {{ $t("assistantsList.perPage") }}
            md-select(v-model='pagination.perPage' name='pages')
              md-option(
                v-for='item in pagination.perPageOptions',
                :key='item',
                :label='item',
                :value='item') {{ item }}
          md-field
            md-input.mb-3(
              type='search'
              clearable
              style='width: 200px;',
              :placeholder='$t("assistantsList.search") + "..."'
              v-model='searchQuery')
        md-table-row(
          @click='selectSnapshot(item)'
          slot='md-table-row'
          slot-scope='{ item }',
          :class='{ "item-selected": item._id === snapshotActive }'
          style='cursor: pointer;')
          md-table-cell(md-label='id') {{ item._id }}
          md-table-cell(:md-label='$t("commonWords.description")')
            | {{ item._source.description }}
          md-table-cell(:md-label="$t('selectSnapshot.createdAt')")
            | {{ calculateCreatedData(item._source.createdAt).value }} &nbsp;
            | {{ calculateCreatedData(item._source.createdAt).type }}
          md-table-cell(:md-label='$t("selectSnapshot.updatedTo")')
            | {{ calculateCreatedData(item._source.updatedAt).value }} &nbsp;
            | {{  calculateCreatedData(item._source.updatedAt).type }}
          md-table-cell(:md-label='$t("commonWords.createdBy")')
            | {{ createdByUser(item) ? $t("commonWords.me") : item._source.createdBy && item._source.createdBy.name }}
          md-table-cell(:md-label='$t("selectSnapshot.userEditor")')
            | {{ ownedByUser(item) ? $t("commonWords.I") : item._source.checkedOutBy && item._source.checkedOutBy.name }}
          md-table-cell(md-label='Status')
            | {{ item._source.status }}
    md-card-actions(md-alignment='space-between')
      div
        p.card-category
          | {{ $t("assistantsList.showingItems", { from: from + 1, to: to, total: pagination.total }) }}
      pagination.pagination-no-border.pagination-success(
        v-model='pagination.page',
        :per-page='pagination.perPage',
        :total='pagination.total')
</template>

<script>
import debounce from 'lodash/debounce'
import Pagination from '@/components/Pagination.vue'
import { mapGetters } from 'vuex'
import BotPageTitle from '@/components/BotPageTitle.vue'
export default {
  name: 'SelectSnapshot',
  components: {
    Pagination,
    BotPageTitle
  },
  props: {
    workspaceId: {
      type: String,
      required: true
    }
  },
  watch: {
    searchQuery: debounce(async function () {
      this.populateSnapshots()
    }, 466),
    'pagination.page': 'populateSnapshots',
    workspaceId: {
      handler: 'init',
      immediate: true
    }
  },
  computed: {
    ...mapGetters('auth', ['token']),
    // ...mapGetters('snapshots', {
    //   tableData: 'snapshots',
    //   viewingMode: 'viewingMode',
    //   appliedSnapshot: 'appliedSnapshot'
    // }),
    // não precisa alterar nada aqui
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.pagination.total < highBound) {
        highBound = this.pagination.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.page - 1)
    }
  },
  data () {
    return {
      tableData: [],
      snapshotActive: null,
      // ordenado por:
      currentSort: 'name',
      currentSortOrder: 'asc',
      // paginação:
      pagination: {
        perPage: 5,
        page: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      // searchQuery é o que tá lá no computed. propsToSearch é qual das labels que vão estar incluídas na pesquisa
      // baseado no nome do campo do objeto do item
      searchQuery: '',
      propsToSearch: ['name', 'channel', 'test'],
      // conteúdo
      searchedData: [],
      fuseSearch: null,
      tableKey: 0,
      loading: true
    }
  },
  beforeMount () {
    // window.addEventListener('beforeunload', this.preventNav)
    // this.$once('hook:beforeDestroy', () => {
    //   window.removeEventListener('beforeunload', this.preventNav)
    // })
  },
  methods: {
    init () {
      this.pagination = {
        perPage: 5,
        page: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      }
      this.currentSort = 'name'
      this.currentSortOrder = 'asc'
      this.searchQuery = ''
      this.populateSnapshots()
    },
    selectSnapshot (snapshot) {
      // console.log('aaa')
      this.snapshotActive = snapshot._id
      this.$emit('selected-snapshot', snapshot)
    },
    async populateSnapshots () {
      this.loading = true
      // this.loadingText = 'Buscando Snapshots...'
      const result = await this.$axios.get(`/snapshots`, {
        params: {
          noData: true,
          workspace: this.workspaceId,
          perPage: this.pagination.perPage,
          page: this.pagination.page - 1,
          q: this.searchQuery || null
        }
      })
      const snapshots = result.data
      snapshots.data.forEach((snap) => {
        delete snap._source.changes
      })
      // console.log(`result`, result)
      this.pagination.total = snapshots.total
      this.tableData = snapshots.data || []
      this.tableKey++
      this.loading = false
    },
    // preventNav (event) {
    //   if (!this.loading) return
    //   event.preventDefault()
    //   event.returnValue = ''
    // },
    ownedByUser (snapshot) {
      return (
        snapshot._source.checkedOutBy?.id === this.$store.state.auth.user.id
      )
    },
    createdByUser (snapshot) {
      return snapshot._source.createdBy?.id === this.$store.state.auth.user.id
    },
    selectImport (type) {
      this.importType = type
      this.dialogs.import = true
    },
    calculateCreatedData (date) {
      const dCreated = new Date(date)
      const dNow = Date.now()
      const diffTime = Math.abs(dNow - dCreated) / 1000
      if (diffTime < 60) {
        return {
          value: Math.floor(diffTime),
          type: this.evaluateType(Math.floor(diffTime), 'seconds')
        }
      } else if (diffTime < 60 * 60) {
        return {
          value: Math.floor(diffTime / 60),
          type: this.evaluateType(Math.floor(diffTime / 60), 'minutes')
        }
      } else if (diffTime < 60 * 60 * 24) {
        return {
          value: Math.floor(diffTime / (60 * 60)),
          type: this.evaluateType(Math.floor(diffTime / (60 * 60)), 'hours')
        }
      } else {
        return {
          value: Math.floor(diffTime / (60 * 60 * 24)),
          type: this.evaluateType(Math.floor(diffTime / (60 * 60 * 24)), 'days')
        }
      }
    },
    evaluateType (value, type) {
      if (type === 'seconds') {
        return value === 1 ? this.$t('selectSnapshot.second') : this.$t('selectSnapshot.seconds')
      } else if (type === 'minutes') {
        return value === 1 ? this.$t('selectSnapshot.minute') : this.$t('selectSnapshot.minutes')
      } else if (type === 'hours') {
        return value === 1 ? this.$t('selectSnapshot.hour') : this.$t('selectSnapshot.hours')
      } else {
        return value === 1 ? this.$t('selectSnapshot.day') : this.$t('selectSnapshot.days')
      }
    }
  }
}
</script>

<style scoped>
.item-selected {
  color: white;
  background-color: #9c27b0 !important;
}
.table-hover tbody .item-selected:hover {
  background-color: #9025a3 !important;
}
</style>
